namespace GeniuzPOS.SalePromoCamp {
    export enum ApprovePromoFgSelect {
        ApproveFgSelect = 0,
        ApproveFgSelect1 = 1
    }
    Serenity.Decorators.registerEnumType(ApprovePromoFgSelect, 'GeniuzPOS.SalePromoCamp.ApprovePromoFgSelect', 'SalePromoCamp.ApprovePromoFgSelect');
}
